import { environment } from "@root/environments/environment.development";
import { APP_ROUTES } from "@app/app.routes";

export const API_URLS = {
  BASE_URL: `${environment.baseURL}`,
  BASE_URL_MAIN: `${environment.baseURL}/`,
  BASE_URL_SEARCH: `${environment.baseURL}/ws/rest`,
  BASE_URL_VIEW: `${environment.baseURL}/ws/meta/view`,
  BASE_URL_ACTION: `${environment.baseURL}/ws/action`,
  BASE_URL_IMAGE: `${environment.baseURL}/ws/meta-files/file-view`,
  BASE_URL_META: `${environment.baseURL}/ws/meta`,
  BASE_URL_LOGIN: `${environment.baseURL}/callback`,
  BASE_URL_LOGOUT: `${environment.baseURL}/logout`,
  BASE_URL_MENU: `${environment.baseURL}/ws/action/menu/all`,
  BASE_URL_APP_INFO: `${environment.baseURL}/ws/app/info`,
  BASE_URL_REST: `${environment.baseURL}/ws/rest`,
  BASE_URL_FIELDS: `${environment.baseURL}/ws/meta/fields`,
  BASE_URL_HISTORY: `${environment.baseURL}/ws/messages?`,
  BASE_URL_META_FILE: `${environment.baseURL}/ws/meta-files/file-view`,
  BASE_URL_META_FILE_UPLOAD: `${environment.baseURL}/ws/rest/com.axelor.meta.db.MetaFile/upload`,
  BASE_URL_META_FILE_DOWNLOAD: `${environment.baseURL}/ws/rest/com.axelor.meta.db.MetaFile`,
  BASE_URL_WORKING_SHIFT: `${environment.baseURL}/ws/working-shift/get-minutes-until-end-of-working-shift`,
}

export const MENU_URL_MAP: { [key: string]: string } = {
  'transit-control-system-transit-declaration': `/${APP_ROUTES.TRANSIT_DECLARATION}`,
  'registration-root-registration-card': `/${APP_ROUTES.REGISTRATION_CARD}`,
  'registration-root-photo-recording': `/${APP_ROUTES.PHOTO_RECORDING}`,
  'registration-root-vgk': `/${APP_ROUTES.VGK}`,
  'registration-root-idk-inspection': `/${APP_ROUTES.IDK_INSPECTION}`,
  'registration-root-rpm-event': `/${APP_ROUTES.RPM_EVENT}`,
  'preliminary-information-pi-request': `/${APP_ROUTES.PRELIMINARY_INFORMATION_PI_REQUEST}`,
  'preliminary-information-pre-info': `/${APP_ROUTES.PRELIMINARY_INFORMATION_PRE_INFO}`,
  'temporary-import-export-root-temporary-import-export-citd': `/${APP_ROUTES.TEMPORARY_IMPORT_EXPORT_CITD}`,
  'temporary-import-export-root-temporary-import-export-tslp': `/${APP_ROUTES.TEMPORARY_IMPORT_EXPORT_TSLP}`,
  'act-customs-inspection': `/${APP_ROUTES.CUSTOMS_CONTROL_ACT}`,
  'dictionary-event-log-customs-inspection': `/${APP_ROUTES.CUSTOMS_CONTROL_EVENT_LOG}`,
};

